import React from "react";
import NotFoundUi from "../components/NotFoundUi.js";


const NotFound = () => {
  return (
    <>
      <NotFoundUi />
    </>
  );
};

export default NotFound;
